import apiClient from "./utils";

export default {
  sendMessage(data) {
    return apiClient.post("/send_message", data);
  },
};
